// Snaps a position to the nearest grid boundary — the same positions the
// canvas renders as dots/lines (LayoutGrid getCellBoundaries): cell starts at
// k*(step+gap) and, with a gap, also cell ends (start+step). Callers pass the
// object's top-left corner, so that is what lands on a dot. gap=0 degrades to
// plain multiples of step. Returns the value unchanged for a non-positive step.
export const snapToGrid = (value: number, step: number, gap = 0): number => {
  if (!step || step <= 0) {
    return value;
  }

  const period = step + Math.max(0, gap);
  const cell = Math.floor(value / period);
  const candidates = [cell * period, cell * period + step, (cell + 1) * period];

  return candidates.reduce((nearest, candidate) =>
    Math.abs(candidate - value) < Math.abs(nearest - value)
      ? candidate
      : nearest
  );
};
